<template>
	<div>
		<ly-header></ly-header>
		<ly-nav></ly-nav>
		<div class="content">
			<ol class="breadcrumb">
			  <li v-for="el in $route.parent">
			  	<a href="#!{{el.uri}}" title="{{el.title}}" v-if="el.uri != undefined">{{el.title}}</a>
			  	<span v-else>{{el.title}}</span>
			  </li>
			  <li class="active">{{$route.title}}</li>
			</ol>				
			<router-view></router-view>
			<div id="page-404" v-if="!isPage"></div>
		</div>
	</div>
</template>
<script>

	module.exports = {
		computed : {
			isPage : function(){
				return this.$route.matched != null;
			}
		},
		components : {
			'ly-header' : require('../components/Header.vue'),
			'ly-nav' : require('../components/Nav.vue')
		}
	}
</script>


/** WEBPACK FOOTER **
 ** Home.vue?2f7a98ae
 **/